import PicklistMetadata from "../../metadata/picklist/PicklistMetadata";
import picklistMetadataClassFactory from "../../metadata/PicklistMetadataClassFactory";

class Picklist {
    public picklistMetadata: PicklistMetadata = new PicklistMetadata();
    public exclusionList: string[] = [];
    public allowNoSelection: boolean;
    public bounded: boolean;
    public name: string;
    public longList: boolean;
    public searchSpecification: object | null;

    constructor(name: string) {
        let metadataClass = picklistMetadataClassFactory(name);
        // @ts-ignore
        this.picklistMetadata = new metadataClass() as PicklistMetadata;

        this.allowNoSelection = this.picklistMetadata.getAllowNoSelection();
        this.bounded = this.picklistMetadata.getBounded();
        this.name = this.picklistMetadata.getName();
        this.longList = this.picklistMetadata.getLongList();
        this.searchSpecification = this.picklistMetadata.getSearchSpecification();
    };

    getName = (): string => {
        return this.name;
    };

    getBounded = (): boolean => {
        return this.bounded;
    };

    getEnterpriseComponent = () => {
        return this.picklistMetadata.getEnterpriseComponent();
    };

    getLongList = (): boolean => {
        return this.longList;
    };

    getNoDelete = () => {
        return this.picklistMetadata.getNoDelete();
    };

    getNoUpdate = () => {
        return this.picklistMetadata.getNoUpdate();
    };

    getNoInsert = () => {
        return this.picklistMetadata.getNoInsert();
    };

    getNoMerge = () => {
        return this.picklistMetadata.getNoMerge();
    };

    getSearchSpecification = () => {
        return this.searchSpecification;
    };

    getSortSpecification = () => {
        return this.picklistMetadata.getSortSpecification();
    };

    getStatic = () => {
        return this.picklistMetadata.getStatic();
    };

    getTypeField = () => {
        return this.picklistMetadata.getTypeField();
    };

    getTypeValue = () => {
        return this.picklistMetadata.getTypeValue();
    };

    getVisibilityType = () => {
        return this.picklistMetadata.getVisibilityType();
    };

    getAllowNoSelectionDisplayValue = () => {
        return this.picklistMetadata.getAllowNoSelectionDisplayValue();
    };

    getAllowNoSelection = () => {
        return this.allowNoSelection;
    };

    getAllowNoSelectionValue = () => {
        return this.picklistMetadata.getAllowNoSelectionValue();;
    };

    getHierarchical = () => {
        return this.picklistMetadata.getHierarchical();
    };

    getHierarchyParentField = () => {
        return this.picklistMetadata.getHierarchyParentField();
    };

    getSecondaryDisplayField = () => {
        return this.picklistMetadata.getSecondaryDisplayField();
    };

    getSecondaryDisplayLabel = () => {
        return this.picklistMetadata.getSecondaryDisplayLabel();
    };

    getExclusionList = () => {
        return this.exclusionList;
    };

    reevaluateMetadata() {
        let metadataClass = picklistMetadataClassFactory(this.name);
        // @ts-ignore
        this.picklistMetadata = new metadataClass() as PicklistMetadata;
    }

    setExclusionList = (valuesToExclude: string[]) => {
        this.exclusionList = valuesToExclude;
    };

    setSearchSpecification = (searchSpecification: object) => {
        this.searchSpecification = searchSpecification;
    };

    setAllowNoSelection = (allowNoSelection: boolean) => {
        this.allowNoSelection = allowNoSelection;
    }
}

export default Picklist;